import { formatTime, isSameDay, toDateKey } from "../../utils/date";
import { cx } from "../../utils/classNames";
import {
  formatRecordHours,
  getStatusForDate,
  STATUS_LABELS,
} from "./attendanceStatus";
import AwayPin from "./AwayPin";
import { DayFlags } from "./components/DayFlags";
import DayMapLink from "./components/DayMapLink";
import styles from "./AttendanceView.module.css";

const AttendanceWeekView = ({ days, recordsByDate }) => {
  const today = new Date();

  return (
    <div className={styles.weekWrapper}>
      <div className={styles.weekGrid}>
        {days.map((date) => {
          const key = toDateKey(date);
          const record = recordsByDate[key];
          const status = getStatusForDate(date, recordsByDate);

          return (
            <div
              key={key}
              className={cx(
                styles.weekCell,
                styles[status],
                isSameDay(date, today) && styles.isToday,
              )}
            >
              <div>
                <div className={styles.weekDayName}>
                  {date.toLocaleDateString("en-PH", { weekday: "short" })}
                </div>
                <div className={styles.weekDate}>{date.getDate()}</div>
              </div>

              <span className={styles.weekStatusPill}>
                <span className={styles.statusDot}></span>
                {STATUS_LABELS[status]}
              </span>

              <div>
                <div className={styles.weekDetailRow}>
                  <span>In</span>
                  <span>
                    {formatTime(record?.checkInTime)}
                    {record?.checkInOutsideBranch === true && <AwayPin />}
                  </span>
                </div>
                <DayMapLink record={record} kind="in" />
                <div className={styles.weekDetailRow}>
                  <span>Out</span>
                  <span>
                    {formatTime(record?.checkOutTime)}
                    {record?.checkOutOutsideBranch === true && <AwayPin />}
                  </span>
                </div>
                <DayMapLink record={record} kind="out" />
                <div className={styles.weekDetailRow}>
                  <span>Hours</span>
                  <span>{formatRecordHours(record)}</span>
                </div>
                <DayFlags record={record} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AttendanceWeekView;
